import { bookingConstants } from '../../_constants';
import { bookingServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';
import { PickUpExcel } from '../../../components/layout/bookingPdf/PickUpExcel';
import { DeliveryListExcel } from '../../../components/layout/InboundExcel';

export const bookingActions = {
    getBookingSchedules,
    getVoyageForBookingBatch,
    getBookingBatchByVoyageNum,
    loadBookingBatchByVoyageNum,
    CreateBookingBatch,
    updateBookingBatch,
    deleteByBatch,
    sendEmail,
    getBookingBatch,
    createBookingRef,
    deleteByBookingRef,
    cloneBookingRef,
    getBookingRef,
    getMultipleBookingRef,
    getBookingLink,
    searchBooking,
    updateBookingBatchStatus,
    updateMultipleBookingRef,
    updateSingleBooking,
    updateMultipleBookingStatus,
    getVanOutATW,
    getCyBranch,
    getBookingPickUpList,
    getBookingDeliveryListInBound,
    clearMultipleBookingData,
    getAllBookingbyVoyageNum,
    loadAllBookingbyVoyageNum,
    bookingReset,

    operationreports,
    getBookingForCBS,

    bookingReports1,
    bookingByCsrReports,
    voyageHistory,
    sQbasedCommodityReports,
    vesselHistoryReports,

    BookingDocumentTree,

    soundingsReport,
    soundingsReportYear,
    soundingsReportMonth,
    soundingsReportVessel,
    getTallysheetFinalization,
    updateSoundingsReport,

    // REPORTS API
    dwelltimeReport,

    expireBooking,

    revenueReport,

    revenueReportComparative,
};

function bookingReset() { return { type: bookingConstants.BOOKING_RESET } }

function bookingFetching() { return { type: bookingConstants.BOOKING_FETCHING } }
function bookingFetched() { return { type: bookingConstants.BOOKING_FETCHED } }

function bookingSubmitting() { return { type: bookingConstants.BOOKING_SUBMITTING } }
function bookingSubmitted() { return { type: bookingConstants.BOOKING_SUBMITTED } }

function clearMultipleBookingData() { return { type: bookingConstants.CLEAR_MULTIPLE_BOOKING } }

function expireBooking(payload, act, voyageNum, batchRef) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        bookingServices.expireBooking(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Booking was ' + act));
                    window.location.href = '/voyage/bookings/' + voyageNum + '/' + batchRef;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function getBookingForCBS(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingForCBS(payload)
            .then(
                bookingForCBS => {
                        dispatch(success(bookingForCBS));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingForCBS) { return { type: bookingConstants.BOOKING_PRINT_CBS, bookingForCBS } }
}

function BookingDocumentTree(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.BookingDocumentTree(payload)
            .then(
                bookingDocTree => {
                        dispatch(success(bookingDocTree));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingDocTree) { return { type: bookingConstants.BOOKING_DOCUMENT_TREE, bookingDocTree } }
}

function soundingsReport(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.soundingsReport(payload)
            .then(
                soundings => {
                        dispatch(success(soundings));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(soundings) { return { type: bookingConstants.VOYAGE_SOUNDING, soundings } }
}
function soundingsReportYear() {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.soundingsReportYear()
            .then(
                soundingPerYear => {
                        dispatch(success(soundingPerYear));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(soundingPerYear) { return { type: bookingConstants.VOYAGE_SOUNDING_PER_YEAR, soundingPerYear } }
}
function soundingsReportMonth(YEAR) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.soundingsReportMonth(YEAR)
            .then(
                soundingPerMonth => {
                        dispatch(success(soundingPerMonth));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(soundingPerMonth) { return { type: bookingConstants.VOYAGE_SOUNDING_PER_MONTH, soundingPerMonth } }
}
function soundingsReportVessel(MONTH) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.soundingsReportVessel(MONTH)
            .then(
                soundingPerVessel => {
                        dispatch(success(soundingPerVessel));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(soundingPerVessel) { return { type: bookingConstants.VOYAGE_SOUNDING_PER_VESSEL, soundingPerVessel } }
}
function getTallysheetFinalization(id) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getTallysheetFinalization(id)
            .then(
                TSFinal => {
                        dispatch(success(TSFinal));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(TSFinal) { return { type: bookingConstants.VOYAGE_TALLYSHEET_FINALIZE, TSFinal } }
}
function updateSoundingsReport(payload, YEAR, MONTH, VESSEL) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateSoundingsReport(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('Sounding Update Successfully'))
                    window.location.href = '/voyage/soundings/' + YEAR + '/' + MONTH + '/' + VESSEL;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function bookingReports1(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.bookingReports1(payload)
            .then(
                bookReports => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingFetched());
                    dispatch(alertActions.hide("info"));
                    dispatch(success(bookReports));
                    if(bookReports.message){
                        dispatch(alertActions.warning(bookReports.message));
                        dispatch(alertActions.hide("info"));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(success({message: error.toString()}));
                }
            );
    };
    function success(bookReports) { return { type: bookingConstants.BOOK_REPORTS, bookReports } }
}

function bookingByCsrReports(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.bookingByCsrReports(payload)
            .then(
                bookCSRReports => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.hide("info"));
                    dispatch(success(bookCSRReports));
                    dispatch(bookingFetched());
                    if(bookCSRReports.message){
                        dispatch(alertActions.warning(bookCSRReports.message));
                        dispatch(alertActions.hide("info"));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(success({message: error.toString()}));
                }
            );
    };
    function success(bookCSRReports) { return { type: bookingConstants.BOOK_CSRREPORTS, bookCSRReports } }
}

function voyageHistory(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.voyageHistory(payload)
            .then(
                voyageHistory => {
                    dispatch(bookingFetched());
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(voyageHistory));
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(voyageHistory) { return { type: bookingConstants.VOYAGE_HISTORY, voyageHistory } }
}

function vesselHistoryReports(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.vesselHistoryReports(payload)
            .then(
                vesselHistory => {
                        dispatch(success(vesselHistory));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(vesselHistory) { return { type: bookingConstants.VESSEL_HISTORY, vesselHistory } }
}

function sQbasedCommodityReports(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.sQbasedCommodityReports(payload)
            .then(
                SQCommodityReport => {
                        dispatch(success(SQCommodityReport));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(SQCommodityReport) { return { type: bookingConstants.SQ_BASED_GOODS_REPORT, SQCommodityReport } }
}

function operationreports(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.operationreports(payload)
            .then(
                opReports => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.hide("info"));
                    dispatch(success(opReports));
                    dispatch(bookingFetched());
                    if(opReports.message){
                        dispatch(alertActions.warning(opReports.message));
                        dispatch(alertActions.hide("info"));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(success({message: error.toString()}));
                }
            );
    };
    function success(opReports) { return { type: bookingConstants.OPERATION_REPORTS, opReports } }
}

function getBookingSchedules() {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingSchedules()
            .then(
                bookingSchedules => {
                        dispatch(success(bookingSchedules));
                        dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingSchedules) { return { type: bookingConstants.BOOKING_SCHEDULES, bookingSchedules } }
}
function getVoyageForBookingBatch(voyageNum) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getVoyageForBookingBatch(voyageNum)
            .then(
                voyageForBookingBatch => {
                    dispatch(success(voyageForBookingBatch));
                    dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(voyageForBookingBatch) { return { type: bookingConstants.VOYAGE_FOR_BOOKING_BATCH, voyageForBookingBatch } }
}
function getBookingBatchByVoyageNum(voyageNum, search) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingBatchByVoyageNum(voyageNum, search)
            .then(
                bookingsBySchedule => {
                    if (bookingsBySchedule.length > 0) {
                        dispatch(success(bookingsBySchedule));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(bookingsBySchedule.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingsBySchedule) { return { type: bookingConstants.LIST_OF_BOOKINGS_BY_SCHEDULES, bookingsBySchedule } }
}
function loadBookingBatchByVoyageNum(voyageNum, search, skip, take) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.allowLeavePage());
        bookingServices.loadBookingBatchByVoyageNum(voyageNum, search, skip, take)
            .then(
                bookingsBySchedule => {
                    if (bookingsBySchedule.length > 0) {
                        dispatch(success(bookingsBySchedule));
                        dispatch(bookingFetched());
                    } else {
                        // dispatch(alertActions.warning(bookingsBySchedule.message));
                        dispatch(alertActions.warning('No More Data to Load'));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingsBySchedule) { return { type: bookingConstants.LIST_OF_BOOKINGS_BY_SCHEDULES, bookingsBySchedule } }
}
function CreateBookingBatch(payload) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.CreateBookingBatch(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('New booking was added successfully'))
                    window.location.href = '/voyage/bookings/' + payload.voyageNum + '/' + success[0].bookingBatchRef + '/create';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateBookingBatch(payload, id, voyageNum) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateBookingBatch(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('Booking was updated successfully'))
                    window.location.href = '/voyage/bookings/' + voyageNum + '/' + success[0].bookingBatchRef;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteByBatch(id, voyageNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        bookingServices.deleteByBatch(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    // dispatch(getBookingBatchByVoyageNum(voyageNum, null));
                    dispatch(alertActions.success('Booking was deleted successfully'))
                    dispatch(loadBookingBatchByVoyageNum(voyageNum, null, 0, 50));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    // dispatch(getBookingBatchByVoyageNum(voyageNum, null));
                    dispatch(loadBookingBatchByVoyageNum(voyageNum, null, 0, 50));
                }
            );
    };
}
function sendEmail(payload, type, id, voyageNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        bookingServices.sendEmail(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (type === 'bookingRef') {
                        dispatch(getBookingBatch(id, voyageNum, null));
                    } else if (type === 'batchBookingRef') {
                        // dispatch(getBookingBatchByVoyageNum(id, null));
                        dispatch(loadBookingBatchByVoyageNum(id, null, 0, 50));
                    }
                    dispatch(alertActions.success('Booking link was send successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (type === 'bookingRef') {
                        dispatch(getBookingBatch(id, voyageNum, null));
                    } else if (type === 'batchBookingRef') {
                        // dispatch(getBookingBatchByVoyageNum(id, null));
                        dispatch(loadBookingBatchByVoyageNum(id, null, 0, 50));
                    }
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function getBookingBatch(batchRef, voyageNum, search) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.allowLeavePage());
        bookingServices.getBookingBatch(batchRef, voyageNum, search)
            .then(
                batchBooking => {
                    if (batchBooking.length > 0) {
                        dispatch(success(batchBooking));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(batchBooking.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(batchBooking) { return { type: bookingConstants.BOOKING_BY_BATCHREF, batchBooking } }
}
function createBookingRef(payload, voyageNum, batchRef) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.createBookingRef(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('New booking was added successfully'))
                    window.location.href = '/voyage/bookings/' + voyageNum + '/' + batchRef;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function deleteByBookingRef(id, batchRef, link, voyageNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        bookingServices.deleteByBookingRef(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Booking was deleted successfully'))
                    if (batchRef) {
                        if (link) {
                            // dispatch(getAllBookingbyVoyageNum(link));
                            dispatch(loadAllBookingbyVoyageNum(link, null, 0, 50));
                        }
                        else {
                            dispatch(getBookingBatch(batchRef, voyageNum, null));
                        }
                    } else {
                        window.location.href = link;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (batchRef) {
                        dispatch(getBookingBatch(batchRef, voyageNum, null));
                    } else {
                        dispatch(getBookingRef(id));
                    }
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function cloneBookingRef(payload, batchRef, voyageNum) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.cloneBookingRef(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(getBookingBatch(batchRef, voyageNum, null));
                    dispatch(alertActions.success('Booking was cloned successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(getBookingBatch(batchRef, voyageNum, null));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function getBookingRef(bookingRef) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.allowLeavePage());
        bookingServices.getBookingRef(bookingRef)
            .then(
                booking => {
                    if (booking.length > 0) {
                        dispatch(success(booking));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(booking.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(booking) { return { type: bookingConstants.BOOKING_BY_REF, booking } }
}
function getMultipleBookingRef(bookingRef) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getMultipleBookingRef(bookingRef)
            .then(
                multipleBookings => {
                    if (multipleBookings.length > 0) {
                        dispatch(success(multipleBookings));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(multipleBookings.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(multipleBookings) { return { type: bookingConstants.MULTIPLE_BOOKING_BY_REF, multipleBookings } }
}
function getBookingLink(token) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingLink(token)
            .then(
                bookingLink => {
                    dispatch(success(bookingLink));
                    dispatch(bookingFetched());
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingLink) { return { type: bookingConstants.BOOKING_LINK, bookingLink } }
}
function searchBooking(skip, take, search) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.searchBooking(skip, take, search)
            .then(
                searchBookings => {
                    if (searchBookings && searchBookings.bookingRef && searchBookings.bookingRef.length > 0) {
                        dispatch(success(searchBookings));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(searchBookings.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(searchBookings) { return { type: bookingConstants.SEARCH_BOOKINGS, searchBookings } }
}
function updateBookingBatchStatus(bookingRef, field) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateBookingBatchStatus(field)
            .then(
                bookingLink => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('Booking Transaction Updated successfully'));
                    window.location.href = '/booking/success/' + bookingRef;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateMultipleBookingRef(Ref, Booking, isCsr, link) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateMultipleBookingRef(Ref, Booking)
            .then(
                bookingLink => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Booking Updated successfully'))
                    dispatch(bookingSubmitted());
                    if (isCsr) {
                        dispatch(clearMultipleBookingData());
                        setTimeout(() => {
                            window.location.href = link;
                        }, 1000);
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateSingleBooking(Ref, Booking, isCsr, link) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateSingleBooking(Ref, Booking)
            .then(
                bookingLink => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('Booking Updated successfully'))
                    if (isCsr) {
                        dispatch(clearMultipleBookingData());
                        setTimeout(() => {
                            window.location.href = link;
                        }, 1000);
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function updateMultipleBookingStatus(payload, batchRef, voyageNum) {
    return dispatch => {
        dispatch(bookingSubmitting());
        dispatch(userActions.notallowLeavePage());
        bookingServices.updateMultipleBookingStatus(payload)
            .then(
                bookingLink => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.success('Bookings confirmed successfully'));
                    dispatch(getBookingBatch(batchRef, voyageNum, null));
                    dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(getBookingBatch(batchRef, voyageNum, null));
                    dispatch(confirmPromptActions.hide());
                }
            );
    };
}
function getVanOutATW(bookingRef) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getVanOutATW(bookingRef)
            .then(
                bookingForAtw => {
                    if (bookingForAtw.length > 0) {
                        dispatch(success(bookingForAtw));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(bookingForAtw.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(bookingForAtw) { return { type: bookingConstants.BOOKING_FOR_ATW, bookingForAtw } }
}

function getCyBranch(userBranch) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getCyBranch(userBranch)
            .then(
                CyBranch => {
                    if (CyBranch.length > 0) {
                        dispatch(success(CyBranch));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(CyBranch.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(CyBranch) { return { type: bookingConstants.CY_BRANCH, CyBranch } }
}

function getBookingPickUpList(userBranch, branchName, date) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingPickUpList(userBranch, date)
            .then(
                PickUp => {
                    dispatch(alertActions.hide("info"));
                    if (PickUp.length > 0) {
                        PickUpExcel(PickUp, branchName)
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(PickUp.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function getBookingDeliveryListInBound(userBranch) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getBookingDeliveryListInBound(userBranch)
            .then(
                DeliveryList => {
                    if (DeliveryList.length > 0) {
                        dispatch(alertActions.hide("info"));
                        DeliveryListExcel(DeliveryList)
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.hide("info"));
                        dispatch(alertActions.warning(DeliveryList.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(alertActions.hide("info"));
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}

function getAllBookingbyVoyageNum(voyageNum, search) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.getAllBookingbyVoyageNum(voyageNum, search)
            .then(
                bookingsByVoyage => {
                    if (bookingsByVoyage.length > 0) {
                        dispatch(success(bookingsByVoyage));
                        dispatch(bookingFetched());
                    } else {
                        dispatch(alertActions.warning(bookingsByVoyage.message));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingsByVoyage) { return { type: bookingConstants.LIST_OF_BOOKINGS_BY_VOYAGE, bookingsByVoyage } }
}
function loadAllBookingbyVoyageNum(voyageNum, search, skip, take) {
    return dispatch => {
        dispatch(bookingFetching());
        bookingServices.loadAllBookingbyVoyageNum(voyageNum, search, skip, take)
            .then(
                bookingsByVoyage => {
                    if (bookingsByVoyage.length > 0) {
                        dispatch(success(bookingsByVoyage));
                        dispatch(bookingFetched());
                    } else {
                        // dispatch(alertActions.warning(bookingsByVoyage.message));
                        dispatch(alertActions.warning('No More Data to Load'));
                        dispatch(bookingFetched());
                    }
                },
                error => {
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(bookingsByVoyage) { return { type: bookingConstants.LIST_OF_BOOKINGS_BY_VOYAGE, bookingsByVoyage } }
}

// REPORT API
function dwelltimeReport(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.dwelltimeReport(payload)
            .then(
                dwtmReport => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.hide("info"));
                    dispatch(success(dwtmReport));
                    dispatch(bookingFetched());
                    if(dwtmReport.message){
                        dispatch(alertActions.warning(dwtmReport.message));
                        dispatch(alertActions.hide("info"));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(bookingFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(success({message: error.toString()}));
                }
            );
    };
    function success(dwtmReport) { return { type: bookingConstants.DWELLTIME_REPORTS, dwtmReport } }
}

function revenueReport(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.revenueReport(payload)
        .then(
            revenueRprt => {
                dispatch(userActions.allowLeavePage());
                dispatch(success(revenueRprt));
                dispatch(bookingFetched());
            },
            error => {
                dispatch(userActions.allowLeavePage());
                dispatch(bookingFetched());
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function success(revenueRprt) { return { type: bookingConstants.REVENUE_REPORT, revenueRprt } }
}

function revenueReportComparative(payload) {
    return dispatch => {
        dispatch(bookingFetching());
        dispatch(userActions.notallowLeavePage());
        bookingServices.revenueReportComparative(payload)
        .then(
            revenueReportComparative => {
                dispatch(userActions.allowLeavePage());
                dispatch(success(revenueReportComparative));
                dispatch(bookingFetched());
            },
            error => {
                dispatch(userActions.allowLeavePage());
                dispatch(bookingFetched());
                dispatch(alertActions.error(error.toString()));
            }
        );
    };
    function success(revenueReportComparative) { return { type: bookingConstants.REVENUE_REPORT_COMPARATIVE, revenueReportComparative } }
}